import React from 'react';
import PublicLayout from '../../components/layouts/PublicLayout';

const PrivacyPolicy = () => {
  return (
    <PublicLayout>
      <div className="policy-wrapper">
      <div className="policy-container">
        
        <div className="policy-header">
          <div className="header-icon-wrapper">
            <svg className="header-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h1 className="policy-title">Privacy Policy</h1>
          <p className="policy-date">Last Updated: 2026-06-26</p>
        </div>

        <div className="policy-content">
          <section className="intro-section">
            <p>
              At <strong>AlarcTrade</strong>, accessible from our website, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by AlarcTrade and how we use it.
            </p>
            <p>
              If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              1. Information We Collect
            </h2>
            <p>
              The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
            </p>
            <p>
              If you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number. If you make purchases or sell on our platform, financial transaction details will also be processed securely.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
              </svg>
              2. How We Use Your Information
            </h2>
            <p>We use the information we collect in various ways, including to:</p>
            <ul className="custom-list">
              <li>Provide, operate, and maintain our website and services</li>
              <li>Improve, personalize, and expand our website and services</li>
              <li>Understand and analyze how you use our website and services</li>
              <li>Develop new products, services, features, and functionality</li>
              <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
              <li>Send you emails and process transactions</li>
              <li>Find and prevent fraud</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
              3. Share of Information
            </h2>
            <p>
              We do not sell, trade, or rent your personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates, and advertisers.
            </p>
            <p>
              We may use third-party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              4. Data Security
            </h2>
            <p>
              We adopt appropriate data collection, storage, and processing practices and security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information, username, password, transaction information, and data stored on our Site.
            </p>
          </section>

          <section className="policy-section">
            <h2 className="section-title">
              <svg className="section-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m0 0a2 2 0 01-2 2m2-2a2 2 0 00-2-2m2 2a2 2 0 01-2 2m0 0a2 2 0 01-2-2m2 2a2 2 0 00-2-2m2 2V3a1 1 0 10-2 0v4M14 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              5. Your GDPR and Privacy Rights
            </h2>
            <p>
              We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
            </p>
            <ul className="custom-list">
              <li><strong>The right to access</strong> – You have the right to request copies of your personal data.</li>
              <li><strong>The right to rectification</strong> – You have the right to request that we correct any information you believe is inaccurate.</li>
              <li><strong>The right to erasure</strong> – You have the right to request that we erase your personal data, under certain conditions.</li>
              <li><strong>The right to restrict processing</strong> – You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
            </ul>
          </section>

          <section className="policy-section">
            <div className="contact-card">
              <h2 className="contact-title">Questions about your privacy?</h2>
              <p className="contact-subtitle">If you have any questions about this Privacy Policy, please feel free to reach out to us:</p>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="label">Email:</span>
                  <a href="mailto:contact@alarctrade.com" className="text-link font-medium">contact@alarctrade.com</a>
                </div>
                <div className="contact-item">
                  <span className="label">Address:</span>
                  <span className="address-text">C/O KAWOSHE ACHUMI, DOPN
CHEKIYE, BLOCK 5. AGASA 4TH MILE, DIMAPUR
797115</span>
                </div>
              </div>
            </div>
          </section>
        </div>

      </div>
    </div>
    </PublicLayout>
  );
};

export default PrivacyPolicy;
